// Product data for Joseph Graves Art Gallery
// Updated with actual products and pricing

export const PAYMENT_URL = "https://pay.josephgravesjr.com";

export const CATEGORIES = [
  {
    id: "limited-edition-prints",
    name: "Limited Edition Prints",
    icon: "Award",
    tier: "hero"
  },
  {
    id: "original-paintings",
    name: "Original Paintings",
    icon: "Palette",
    tier: "hero"
  },
  {
    id: "apparel",
    name: "Apparel",
    icon: "Shirt",
    tier: "middle"
  },
  {
    id: "childrens-books",
    name: "Children's Books",
    icon: "BookOpen",
    tier: "middle"
  },
  {
    id: "paper-goods",
    name: "Paper Goods",
    icon: "Mail",
    tier: "bottom"
  },
  {
    id: "prints",
    name: "Prints",
    icon: "Image",
    tier: "bottom"
  }
];

export const PRODUCTS = {
  "limited-edition-prints": [
    {
      id: "lep-001",
      title: "The Pink Cowboy",
      description: "Signed, limited edition print. 13\"×19\" archival giclée on premium cotton paper.",
      price: 200,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8e43o2fp_Pink%20Cowboy.jpg",
      badge: "Limited Edition"
    },
    {
      id: "lep-003",
      title: "She So Pretty",
      description: "Signed, limited edition print. 13\"×19\" archival fine art paper.",
      price: 200,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/gzd28o6h_She%20so%20pretty.jpg",
      badge: "Limited Edition"
    },
    {
      id: "lep-004",
      title: "Sunflower Field",
      description: "Signed, limited edition print. 13\"×19\" premium giclée print.",
      price: 200,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/szqsgq2l_Sunflowers.jpg",
      badge: "Limited Edition"
    },
    {
      id: "lep-005",
      title: "I Always Wanted a Donkey",
      description: "Signed, limited edition print. 13\"×19\" archival giclée on premium cotton paper.",
      price: 200,
      printUrl: "https://josephgravesart.level.press/s/i-always-wanted-a-donkey",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/h8ku13gv_donkey.jpg",
      badge: "Limited Edition"
    },
    {
      id: "lep-006",
      title: "When There's Smoke...",
      description: "Signed, limited edition print. 13\"×19\" archival giclée on premium cotton paper.",
      price: 200,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/5eb3n758_When%20There%27s%20Smoke....jpg",
      badge: "Limited Edition"
    },
    {
      id: "lep-007",
      title: "Sunflower Between Us",
      description: "Signed, limited edition print. 13\"×19\" archival giclée on premium cotton paper.",
      price: 200,
      printUrl: "https://josephgravesart.level.press/s/the-sunflower-between-us",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/53a1jd1p_Sunflower%20Between%20Us.JPG",
      badge: "Limited Edition"
    }
  ],
  "original-paintings": [
    {
      id: "op-001",
      title: "The Pink Cowboy",
      description: "Original mixed media on canvas. Bold, vibrant portrait featuring signature map-patterned cowboy hat. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/5rsgdx79_Graves%2C%20Joseph%2C%20AWsample2.JPG",
      badge: "Original"
    },
    {
      id: "op-002",
      title: "Nupe",
      description: "Original mixed media on canvas. Striking portrait with bold red bow tie. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/epjbtgzw_63472DB6-E76E-4B90-9A95-F5FE8D9D2F7B.jpg",
      badge: "Original"
    },
    {
      id: "op-003",
      title: "Ode to Hip Hop",
      description: "Original mixed media on canvas. Vibrant celebration of hip hop culture. Certificate of authenticity included.",
      price: 5000,
      priceLabel: "Inquire",
      paymentUrl: "https://square.link/u/3oGNlZvj",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/bqfs4ptp_Ode%20to%20Hip%20Hop.JPG",
      badge: "Original"
    },
    {
      id: "op-004",
      title: "The Boxer",
      description: "Original painting on canvas. Powerful portrait of a champion. Certificate of authenticity included.",
      price: 3000,
      priceLabel: "Inquire",
      paymentUrl: "https://square.link/u/L3emnrus",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/xhuboijn_IMG_8039.JPG",
      badge: "Original"
    },
    {
      id: "op-005",
      title: "Lady in Green",
      description: "Original mixed media on canvas, 48\" × 48\". A bold back-turned portrait in emerald layered over hand-collaged African textile patterns, gold leaf, and painted script. Signed by the artist. Certificate of authenticity included.",
      price: null,
      priceLabel: "$12,000",
      printUrl: "https://josephgravesart.level.press/s/lady-in-green",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/zhbyowjt_Lady%20in%20Green%20-%20edit.webp",
      images: [
        { id: "full", label: "Full", url: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/zhbyowjt_Lady%20in%20Green%20-%20edit.webp" },
        { id: "detail-gold-leaf", label: "Gold Leaf", url: "/detail-shots/lady-in-green/detail-1-gold-leaf.jpg" },
        { id: "detail-hat-braid", label: "Hat & Braid", url: "/detail-shots/lady-in-green/detail-2-hat-braid.jpg" },
        { id: "detail-textile", label: "Textile Detail", url: "/detail-shots/lady-in-green/detail-3-textile.jpg" }
      ],
      badge: "Original"
    },
    {
      id: "op-006",
      title: "Put On the Red Dress",
      description: "Original painting on canvas. Stunning cowgirl at sunset with mountain backdrop. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9guy62pq_Put%20On%20the%20Red%20Dress.JPG",
      badge: "Original"
    },
    {
      id: "op-007",
      title: "Cowboy Shredder",
      description: "Original mixed media on canvas. Dynamic cowboy snowboarding scene. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/setume61_cowboy%20shredder.jpeg",
      badge: "Original"
    },
    {
      id: "op-008",
      title: "Oh Beautiful",
      description: "Original painting on canvas. Majestic horse portrait with sunflowers and mountain backdrop. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/4pxji9ml_freedoms%20touch.jpeg",
      badge: "Original"
    },
    {
      id: "op-009",
      title: "Mile High Maverick",
      description: "Original mixed media on canvas. Bold cowboy portrait with snow-capped mountains. Certificate of authenticity included.",
      price: 10000,
      priceLabel: "Inquire",
      paymentUrl: "https://square.link/u/DGDBvWO7",
      printUrl: "https://josephgravesart.level.press/s/mile-high-maverick",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/67shu3r6_maverick.jpeg",
      badge: "Original"
    },
    {
      id: "op-010",
      title: "Made U Look",
      description: "Original painting on canvas. Captivating portrait with bold colors and expressive style. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      printUrl: "https://josephgravesart.level.press/s/made-u-look",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/pm4txddw_look%20at%20me.webp",
      badge: "Original"
    },
    {
      id: "op-011",
      title: "Prince v. MJ",
      description: "Original mixed media on canvas. Epic tribute to two music legends. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/fahfrhx5_Prince%20v.%20MJ.jpg",
      badge: "Original"
    },
    {
      id: "op-012",
      title: "Big Black Cock",
      description: "Original painting on canvas. Bold rooster portrait with vibrant turquoise background. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/6ckgzba7_Big%20Black%20Cock.jpg",
      badge: "Original"
    },
    {
      id: "op-013",
      title: "Major - Whirlwind",
      description: "Original painting on canvas. Majestic horse portrait. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/n6o9uoyw_Major%20-%20Whirlwind.jpg",
      badge: "Original"
    },
    {
      id: "op-014",
      title: "Modern Cowboy",
      description: "Original mixed media on canvas. Contemporary cowboy with desert landscape and map elements. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9on9jq5u_Modern%20Cowboy.jpg",
      badge: "Original"
    },
    {
      id: "op-015",
      title: "Chocolate Honey",
      description: "Original painting on canvas. Stunning cowgirl portrait with vibrant colors. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      printUrl: "https://josephgravesart.level.press/s/chocolate-honey",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8ysbjnsb_Chocolate%20Honey.JPG",
      badge: "Original"
    },
    {
      id: "op-016",
      title: "Sunrise Ryder",
      description: "Original painting on canvas. Cowboy at golden hour with stunning sky. Certificate of authenticity included.",
      price: null,
      priceLabel: "Inquire",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/20xknqdf_Sunrise%20Ryder-1.jpg",
      badge: "Original"
    },
    {
      id: "op-017",
      title: "Motown",
      description: "Original mixed media on canvas. Tribute to Motown legends. Certificate of authenticity included.",
      price: 1100,
      priceLabel: "Inquire",
      paymentUrl: "https://square.link/u/mGNUJLJU",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/di107frk_Motown.jpg",
      badge: "Original"
    },
    {
      id: "op-018",
      title: "Miss Lady",
      description: "Original painting on canvas. Elegant cowgirl portrait with vibrant pink and purple tones. Certificate of authenticity included.",
      price: 1400,
      priceLabel: "Inquire",
      paymentUrl: "https://square.link/u/iYvOdPU3",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/wymb5wr8_Miss%20Lady.jpeg",
      badge: "Original"
    },
    {
      id: "op-019",
      title: "Whiskey Smoke II",
      description: "Original painting on canvas. Moody still life featuring cigar and whiskey glass. Certificate of authenticity included.",
      price: 5000,
      priceLabel: "Inquire",
      paymentUrl: "https://square.link/u/qRUZiAFE",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9mf7nwup_Whiskey%20Smoke%20II.JPG",
      badge: "Original"
    },
    {
      id: "op-020",
      title: "Wally",
      description: "Original acrylic on canvas, 36\" × 48\". A larger-than-life rider — mountain-mirror shades, feathered coat aflame in red and gold — mounted on horseback against a green and violet horizon. Signed by the artist. Certificate of authenticity included.",
      price: 2000,
      priceLabel: "Inquire",
      printUrl: "https://josephgravesart.level.press/s/wally",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/7ggee2e1_Wallyy.webp",
      badge: "New"
    },
    {
      id: "op-021",
      title: "Cruise",
      description: "Original mixed media on canvas. A lone cowboy silhouette astride a bicycle rolling across a golden desert horizon — reflections shimmering on the mirrored ground below. Signed by the artist. This original has found its home. Prints available.",
      price: null,
      priceLabel: "Sold",
      printUrl: "https://josephgravesart.level.press/s/cruise",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/rgf1njvf_cruise.webp",
      sold: true,
      badge: "Sold"
    },
    {
      id: "op-022",
      title: "Native Perspective",
      description: "Original acrylic on canvas. A dual portrait of two Native figures in ceremonial regalia — jewelry, feathers, and fringed leather rendered with palette-knife energy against a bold sweep of cobalt, gold, and turquoise. Signed by the artist. This original has found its home.",
      price: null,
      priceLabel: "Sold",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/9fhbgbfe_Native%20Perspective.webp",
      sold: true,
      badge: "Sold"
    }
  ],
  "apparel": [
    {
      id: "ap-001",
      title: "Black Cowboys Exist Hoodie",
      description: "Premium heavyweight hoodie featuring the \"Black Cowboys Exist\" design. Comfortable and stylish.",
      price: 90,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/nx77yr2a_Screenshot%202026-01-09%20at%202.16.58%E2%80%AFPM.png",
      images: [
        { id: "front", label: "Front", url: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/2g4unqd4_Screenshot%202026-01-14%20at%209.43.22%20PM.png" },
        { id: "back", label: "Back", url: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/nx77yr2a_Screenshot%202026-01-09%20at%202.16.58%E2%80%AFPM.png" },
        { id: "lifestyle", label: "In the Wild", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/gxbo3noe_back%20of%20hoodie.png" }
      ],
      badge: null
    },
    {
      id: "ap-002",
      title: "Black Cowboys Exist T-Shirt",
      description: "Classic fit cotton t-shirt with \"Black Cowboys Exist\" design. Available in multiple sizes.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/3i0j23yy_Screenshot%202026-01-14%20at%209.43.39%20PM.png",
      images: [
        { id: "front", label: "Front", url: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/3i0j23yy_Screenshot%202026-01-14%20at%209.43.39%20PM.png" },
        { id: "back", label: "Back", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/niwc0gz6_IMG_3762.jpg" }
      ],
      badge: null
    },
    {
      id: "ap-003",
      title: "Black Cowboys Exist Cap",
      description: "Signature Black Cowboys Exist cow embroidered on a black brushed-cotton dad cap. Signed leather patch with brass grommets on the adjustable strap. One size, unisex. A quiet, everyday piece of the studio.",
      price: 40,
      paymentUrl: "https://square.link/u/xZnsrp9z",
      image: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/yf2ihxp6_IMG_1905%202.jpg",
      images: [
        { id: "front", label: "Front", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/yf2ihxp6_IMG_1905%202.jpg" },
        { id: "model", label: "Model", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/2n5t58z2_IMG_1918%202.jpg" },
        { id: "angle", label: "Angle", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/dzmre9ke_IMG_1919%202.jpg" },
        { id: "detail", label: "Detail", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/84h2nlar_IMG_1918%203.jpg" },
        { id: "studio", label: "Studio", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/fc8bzt69_IMG_1905.jpg" }
      ],
      badge: "New"
    },
    {
      id: "ap-004",
      title: "Boot Stitch Trucker Hat",
      description: "Tan suede trucker hat with classic boot stitch embroidery. Signed leather patch with brass snap closure on the back.",
      price: 30,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/65996fzc_Boot%20stitch%20Style%20Trucker.webp",
      images: [
        { id: "front", label: "Front", url: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/65996fzc_Boot%20stitch%20Style%20Trucker.webp" },
        { id: "back", label: "Back", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/kz5wkvzm_IMG_3795.JPG" },
        { id: "detail", label: "Detail", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/qir638kj_IMG_3796.JPG" }
      ],
      badge: null
    },
    {
      id: "ap-005",
      title: "Black Cowboys Exist Patch",
      description: "Iron-on/sew-on embroidered patch featuring the signature Black Cowboys Exist cow. Wear it on a jacket, cap, or tote. Every patch is a small piece of the studio.",
      price: 5,
      paymentUrl: "https://square.link/u/TRec5Htx",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/bg8d2t7l_IMG_4097.jpeg",
      badge: "New"
    },
    {
      id: "ap-006",
      title: "Black Cowboys Exist Sticker",
      description: "Weatherproof vinyl sticker of the signature Black Cowboys Exist cow. For laptops, bottles, guitar cases, and everywhere else worth marking.",
      price: 3,
      paymentUrl: "https://square.link/u/DPrss60y",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/bg8d2t7l_IMG_4097.jpeg",
      badge: "New"
    }
  ],
  "childrens-books": [
    {
      id: "cb-001",
      title: "Daddy Joe's Cowboy Capers",
      description: "A whimsical illustrated children's book full of cowboy adventures. Hardcover, signed by the artist.",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/7g18ogrj_Cowboy%20capers.jpg",
      images: [
        { id: "cover", label: "Cover", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/7g18ogrj_Cowboy%20capers.jpg" },
        { id: "spread-1", label: "Meet Jojo", url: "/book-previews/cowboy-capers/spread-1.jpg" },
        { id: "spread-2", label: "Spread II", url: "/book-previews/cowboy-capers/spread-2.jpg" },
        { id: "spread-3", label: "Spread III", url: "/book-previews/cowboy-capers/spread-3.jpg" },
        { id: "spread-4", label: "Spread IV", url: "/book-previews/cowboy-capers/spread-4.jpg" },
        { id: "spread-5", label: "Spread V", url: "/book-previews/cowboy-capers/spread-5.jpg" }
      ],
      badge: "Hardcover"
    },
    {
      id: "cb-002",
      title: "You Are An Artist",
      description: "An inspiring children's book encouraging creativity and self-expression. Softcover, beautifully illustrated and signed by the artist.",
      price: 18,
      image: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/mzjfx8i2_Cover.png",
      images: [
        { id: "cover", label: "Cover", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/mzjfx8i2_Cover.png" },
        { id: "spread-1", label: "Come Closer", url: "/book-previews/you-are-an-artist/spread-1.jpg" },
        { id: "spread-2", label: "Spread II", url: "/book-previews/you-are-an-artist/spread-2.jpg" },
        { id: "spread-3", label: "Spread III", url: "/book-previews/you-are-an-artist/spread-3.jpg" },
        { id: "spread-4", label: "Spread IV", url: "/book-previews/you-are-an-artist/spread-4.jpg" },
        { id: "spread-5", label: "Spread V", url: "/book-previews/you-are-an-artist/spread-5.jpg" }
      ],
      badge: "Softcover"
    },
    {
      id: "cb-003",
      title: "The Children's Book Bundle",
      description: "Both signed children's books together: Daddy Joe's Cowboy Capers (hardcover) and You Are An Artist (softcover). Save $3 when you take home the pair — perfect for gifting.",
      price: 40,
      image: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/7g18ogrj_Cowboy%20capers.jpg",
      images: [
        { id: "cowboy-capers", label: "Cowboy Capers", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/7g18ogrj_Cowboy%20capers.jpg" },
        { id: "you-are-an-artist", label: "You Are An Artist", url: "https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/mzjfx8i2_Cover.png" }
      ],
      badge: "Save $3"
    }
  ],
  "paper-goods": [
    {
      id: "pg-001",
      title: "Sunflower Sonata Greeting Card",
      description: "Single greeting card featuring the vibrant Sunflower Sonata artwork. Premium cardstock with matching envelope. Blank inside.",
      price: 10,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/35seky7u_IMG_7648.jpg",
      badge: null
    },
    {
      id: "pg-002",
      title: "Cowboy Greeting Cards",
      description: "Pack of 3 greeting cards featuring the Black Cowboy artwork. Premium cardstock with matching envelopes. Blank inside.",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/t11k2mgu_Black-Cowboy.jpeg",
      badge: null
    },
    {
      id: "pg-003",
      title: "Cowboy Prince Greeting Card",
      description: "Single greeting card featuring the Cowboy Prince artwork. Premium cardstock with matching envelope. Blank inside.",
      price: 10,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/rw0m4cxd_Cowboy%20Prince.jpeg",
      badge: null
    },
    {
      id: "pg-004",
      title: "Mini Print Collection",
      description: "Set of 3 mini prints featuring Black Gold, Sunflower Sonata, and Black Cowboy. Perfect for gifting or framing.",
      price: 25,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/kcpsn40i_Screenshot%202026-01-15%20at%2011.05.26%E2%80%AFAM.png",
      badge: null
    },
    {
      id: "pg-005",
      title: "Reading is Life Greeting Card",
      description: "Single greeting card featuring the \"Reading is Life\" artwork. Premium cardstock with matching envelope. Blank inside.",
      price: 10,
      paymentUrl: "https://square.link/u/ZMIvbSIx",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/i9q33i51_IMG_2678.webp",
      badge: "New"
    },
    {
      id: "pg-006",
      title: "Me and My Dog Greeting Card",
      description: "Single greeting card featuring the \"Me and My Dog\" artwork. Premium cardstock with matching envelope. Blank inside.",
      price: 10,
      paymentUrl: "https://square.link/u/fWRHUT7W",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/jj0f37qc_IMG_2685.webp",
      badge: "New"
    },
    {
      id: "pg-007",
      title: "We Ride After Mimosas Greeting Card",
      description: "Single greeting card featuring the \"We Ride After Mimosas\" artwork. Premium cardstock with matching envelope. Blank inside.",
      price: 10,
      paymentUrl: "https://square.link/u/eOTW2AFc",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/vu5857dc_IMG_2192.webp",
      badge: "New"
    },
    {
      id: "pg-008",
      title: "Card Sampler — Pick 3 for $25",
      description: "Choose any three greeting cards from the studio and save $5 versus buying them individually. Premium cardstock, matching envelopes, blank inside. Perfect gift set — Joseph packs each set by hand.",
      price: 25,
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/i9q33i51_IMG_2678.webp",
      badge: "Save $5"
    }
  ],
  "prints": [
    {
      id: "pr-001",
      title: "Black Cowboy",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      printUrl: "https://josephgravesart.level.press/s/the-black-cowboy",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/rsdmtmxq_Black%20Cowboy.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-002",
      title: "Remembering Josephine",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/x1jowb9q_IMG_4409.JPG",
      badge: "Open Edition"
    },
    {
      id: "pr-003",
      title: "Tutu, Coffee and Wine",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/qm3mtfaw_IMG_6345.JPG",
      badge: "Open Edition"
    },
    {
      id: "pr-005",
      title: "Black Gold",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      printUrl: "https://josephgravesart.level.press/s/black-gold",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8nnxsbaf_Black%20Gold.jpeg",
      badge: "Open Edition"
    },
    {
      id: "pr-006",
      title: "Cowboy Prince",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/u4eu9wky_Cowboy%20Prince.jpeg",
      badge: "Open Edition"
    },
    {
      id: "pr-007",
      title: "Cowboy Shredder",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/twde5cu9_cowboy%20shredder.jpeg",
      badge: "Open Edition"
    },
    {
      id: "pr-008",
      title: "Denim Cowboy",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/oq7g3k9t_denimcowboy.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-009",
      title: "Denim Cowgirl",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/5xzk9hvd_denimcowgirl.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-010",
      title: "Made U Look",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/pm4txddw_look%20at%20me.webp",
      badge: "Open Edition"
    },
    {
      id: "pr-011",
      title: "70's Soul",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/ra7mkx1a_70%27s%20Soul.JPG",
      badge: "Open Edition"
    },
    {
      id: "pr-012",
      title: "Chocolate Honey",
      description: "Limited signed print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 85,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8ysbjnsb_Chocolate%20Honey.JPG",
      badge: "Signed"
    },
    {
      id: "pr-013",
      title: "Big Black Cock",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/6ckgzba7_Big%20Black%20Cock.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-014",
      title: "Major - Whirlwind",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/n6o9uoyw_Major%20-%20Whirlwind.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-015",
      title: "Modern Cowboy",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9on9jq5u_Modern%20Cowboy.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-016",
      title: "Arteoke",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/6aqoqd47_Arteoke.JPG",
      badge: "Open Edition"
    },
    {
      id: "pr-017",
      title: "Hold My Mule",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25.",
      price: 45,
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/l0vcj2rq_Hold%20My%20Mule.jpg",
      badge: "Open Edition"
    },
    {
      id: "pr-018",
      title: "Cruise",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25 and 11\"×14\" for $75. A signature cowboy-on-bike moment — the original has sold, this print keeps the ride going.",
      price: 45,
      printUrl: "https://josephgravesart.level.press/s/cruise",
      image: "https://customer-assets-jai6qajn.emergentagent.net/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/rgf1njvf_cruise.webp",
      badge: "Open Edition"
    },
    {
      id: "pr-019",
      title: "Sunflower Sonata",
      description: "Open edition print. 8\"×10\" with matte. Also available in 5\"×7\" for $25 and 11\"×14\" for $75.",
      price: 45,
      printUrl: "https://josephgravesart.level.press/s/sunflower-sonata",
      image: "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/35seky7u_IMG_7648.jpg",
      badge: "Open Edition"
    }
  ]
};
